class MHeader extends HTMLElement {
    constructor() {
        super(),
            (this.selectors = {
                headers: ["header"],
                logos: [".m-logo"],
                topbar: ".m-topbar",
                headerWrapper: ".m-header__wrapper",
                topbarClose: ".m-topbar__close",
            }),
            (this.domNodes = queryDomNodes(this.selectors, this)),
            (this.innerWidth = window.innerWidth),
            (this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop),
            (this.headerHeight = this.domNodes.headerWrapper.offsetHeight),
            (this.stickyHeader = this.dataset.sticky),
            (this.classes = {
                scrollUp: "scroll-up",
                scrollDown: "scroll-down",
                stuck: "stuck",
                always: "header-sticky-always",
                headerScrollUp: "header-scroll-up",
                headerScrollDown: "header-scroll-down",
            }),
            this.init();
        this.headerTransparentAction()
    }
    init() {
        (this.transparentHeader =
            this.domNodes &&
            this.domNodes.headers[0] &&
            "true" === this.domNodes.headers[0].dataset.transparent),
            this.initAddon(),
            this.handleSticky(),
            document.addEventListener("matchMobile", () => this.handleSticky()),
            document.addEventListener("unmatchMobile", () => this.handleSticky()),
            (this.siteNav = new SiteNav(this)),
            (window.__sfHeader = this),
            window.addEventListener("resize", () => {
                this.innerWidth = window.innerWidth;
            }),
            (this.popupSearch = document.querySelector("[data-search-popup]")),
            (this.specialHomePageSearch = this.querySelectorAll(
                "[header-homepage-special-search]"
            )),
            this.specialHomePageSearch.length > 0 &&
            (this.specialHomePageSearch.forEach((e) =>
                e.addEventListener("click", () => {
                    this.popupSearch.classList.add("active");
                    document.querySelector("m-search-popup").openSearchPopup();
                })
            ),
                this.popupSearch
                    .querySelector("[data-close-search]")
                    .addEventListener("click", () => {
                        this.popupSearch.classList.contains("active") &&
                            this.popupSearch.classList.remove("active");
                    }));
    }
    headerTransparentAction() {
        if (window.screen.width < 768) {
            this.getAttribute('data-mobile-transparent') === 'true' ? this.classList.add("transparent-on-top") : this.classList.remove("transparent-on-top");
        }
    }
    initAddon() {
        (this.megamenu = new Megamenu(this)),
            Shopify.designMode &&
            ((MinimogTheme = MinimogTheme || {}),
                MinimogTheme &&
                MinimogTheme.Wishlist &&
                MinimogTheme.Wishlist.updateWishlistCount());
    }
    handleSticky() {
        let e = 20;
        document
            .querySelectorAll(".shopify-section-group-header-group")
            .forEach((t) => {
                t.classList.contains("m-section-header") ||
                    t.classList.contains("m-section-scaling-logo") ||
                    (e += t.offsetHeight);
            });
        const t = document.querySelector(".m-topbar");
        t && (e += t.offsetHeight);
        let s = 0;
        window.addEventListener("scroll", () => {
            const t = window.scrollY;
            if (t <= e)
                return (
                    this.classList.remove(
                        this.classes.scrollUp,
                        this.classes.stuck,
                        this.classes.always
                    ),
                    void document.body.classList.remove(
                        this.classes.headerScrollUp,
                        this.classes.headerScrollDown
                    )
                );
            "on_scroll_up" === this.stickyHeader
                ? this.classList.add(this.classes.stuck)
                : "always" === this.stickyHeader &&
                this.classList.add(this.classes.always),
                t > this.headerHeight + e &&
                    t > s &&
                    !this.classList.contains(this.classes.scrollDown)
                    ? (this.classList.remove(this.classes.scrollUp),
                        document.body.classList.remove(this.classes.headerScrollUp),
                        this.classList.add(this.classes.scrollDown),
                        document.body.classList.add(this.classes.headerScrollDown))
                    : t < s &&
                    this.classList.contains(this.classes.scrollDown) &&
                    (this.classList.remove(this.classes.scrollDown),
                        document.body.classList.remove(this.classes.headerScrollDown),
                        this.classList.add(this.classes.scrollUp),
                        document.body.classList.add(this.classes.headerScrollUp)),
                (s = t);
        });
    }
}
customElements.define("m-header", MHeader);
class AnimatedSearchText extends HTMLElement {
    constructor() {
        super(),
            (this.elsElement = this.querySelector(
                'script[data-animated-search-text-el="data"]'
            )),
            (this.elsTextElement = this.querySelector(
                '[data-animated-search-text-el="text"]'
            ));
    }
    connectedCallback() {
        this.cycle();
    }
    async typeText(e) {
        const t = e.split("");
        for (let e = 0; e < t.length; e++)
            (this.elsTextElement.textContent += t[e]),
                await this.delay(this.typeSpeed);
    }
    async deleteText() {
        for (let e = this.elsTextElement.textContent.split("").length; e >= 0; e--)
            (this.elsTextElement.textContent = this.elsTextElement.textContent.slice(
                0,
                e
            )),
                await this.delay(this.deleteSpeed);
    }
    async cycle() {
        for (let e = 0; e < this.data.length; e++)
            (this.elsTextElement.textContent = ""),
                await this.typeText(this.data[e]),
                await this.delay(this.deleteDelay),
                await this.deleteText(),
                await this.delay(this.nextWordDelay);
        this.cycle();
    }
    delay(e) {
        return new Promise((t) => setTimeout(t, e));
    }
    get data() {
        return JSON.parse(this.elsElement.textContent);
    }
    get typeSpeed() {
        return this.dataset.typeSpeed;
    }
    get deleteSpeed() {
        return this.dataset.deleteSpeed;
    }
    get deleteDelay() {
        return this.dataset.deleteDelay;
    }
    get nextWordDelay() {
        return this.dataset.nextWordDelay;
    }
}
customElements.get("animated-search-text") ||
    customElements.define("animated-search-text", AnimatedSearchText);
